import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import NotificacaoFaturaList from './NotificacaoFaturaList';
import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import NotificacaoFaturaCadastrar from './NotificacaoFaturaCadastrar';
import { Messages } from 'primereact/messages';
import postNotificacaoFatura from "../../service/postNotificacaoFatura";
import putNotificacaoFatura from '../../service/putNotificacaoFatura';

export default function NotificacaoFaturaPage() {
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const [notificacaoFatura, setNotificacaoFatura] = useState<any | null>(null);
  const labelButton = t('cadastrar')
  const saveNotificacaoFatura = (notificacaoFatura:any) => {
    if(notificacaoFatura.id){
      putNotificacaoFatura(notificacaoFatura).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
            ]);
          }
        }
        else{
          setNotificacaoFatura(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
            ]);
          }
        }
      })
    }
    else{
      postNotificacaoFatura(notificacaoFatura).then(data => {
        if(data.includes('Erro')){
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }
            ]);
          }
        }
        else{
          setNotificacaoFatura(null);
          if (msgs.current) {
            msgs.current?.clear();
            msgs.current?.show([
                { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
            ]);
          }
        }
      })
    }
  }
  const startContent = (
    <React.Fragment>
        <Button label={labelButton} icon="pi pi-plus" style={{backgroundColor:'#183462'}} onClick={() => {setNotificacaoFatura({})}}/>
    </React.Fragment>
);

  return (
    <Container>
      <div className="row">
          <div className="col-lg-12 mb-3">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
              <h1 className="h3 mb-0 text-gray"><i className="pi pi-bell" style={{ fontSize: '2.0rem' }}></i> {t('notificacoesFatura')}</h1>
            </div>
          </div>
      </div>
      <div className="card">
        <Messages ref={msgs} />
        {!notificacaoFatura && (
          <>
            <Toolbar start={startContent} />
            <br></br>
            <br></br>
            <NotificacaoFaturaList onEdit={(notificacaoFatura:any) => { setNotificacaoFatura(notificacaoFatura);}}></NotificacaoFaturaList>
          </>
        )}
        {notificacaoFatura && (
          <>
           <NotificacaoFaturaCadastrar msgs={msgs} notificacaoFatura={notificacaoFatura} onSave={saveNotificacaoFatura} onClose={() => {setNotificacaoFatura(null)}}></NotificacaoFaturaCadastrar>
          </>
        )}
      </div>

    </Container>
  )
}
